import { Component, OnInit, OnDestroy } from '@angular/core';
import { BehaviorSubject, take, Subscription, first } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CreatorType } from 'src/patient-manager/common/enums/creator-type';
import { ReleaseCodeType } from 'src/patient-manager/common/enums/release-code-type';
import { SubscriptionDurationType } from 'src/patient-manager/common/enums/subscription-duration-type';
import { ServerValueInterpreterService } from 'src/common-panel/services/server-value-interpreter.service';
import { environment } from 'src/environments/environment';
import { CountriesEnum } from 'src/common-panel/enums/countries-enum';
import { ReleaseCodeService } from 'src/patient-manager/services/release-code.service';
import { COUNTRIES_IDS, CountryId } from 'src/common-panel/constants/country-configs.constants';

@Component({
  selector: 'app-generate-codes-csv-dialog',
  templateUrl: './generate-codes-csv-dialog.component.html',
  styleUrl: './generate-codes-csv-dialog.component.css',
  standalone: false
})
export class GenerateCodesCSVDialogComponent implements OnInit, OnDestroy
{
  subscription: Subscription = new Subscription()
  loaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true)

  form: FormGroup = new FormGroup({
    count: new FormControl(1, [Validators.required]),
    type: new FormControl(ReleaseCodeType.none, [Validators.required]),
    soundTherapy: new FormControl(false),
    cbt: new FormControl(false),
    subscriptionDuration: new FormControl(null),
    trialDuration: new FormControl(null),
    countryOfCreation: new FormControl(null, [Validators.required]),
    shopId: new FormControl(null),
    hcpId: new FormControl(null),
    entOfficeId: new FormControl(null),
    entId: new FormControl(null),
    // creator: new FormControl(CreatorType.admin, [Validators.required]),
    creatorName: new FormControl('Admin panel'),
    notes: new FormControl(null),
    withQRcodes: new FormControl(false)
  })

  ReleaseCodeType = ReleaseCodeType
  SubscriptionDurationType = SubscriptionDurationType
  CreatorType = CreatorType
  isSubscription: boolean = false
  isPrescription: boolean = false
  withDuration: boolean = false
  CountriesIDs = COUNTRIES_IDS

  constructor(private dialogRef: MatDialogRef<any>, private serverValueInterpreterService: ServerValueInterpreterService,
    private releaseCodeService: ReleaseCodeService
  )
  {
  }

  ngOnInit(): void
  {

    this.dialogRef.afterClosed().pipe(take(1)).subscribe(() =>
    {
      this.releaseCodeService.clearAll()
    })

    let l_sub = this.form.controls['type'].valueChanges.subscribe(() =>
    {
      if (this.form.controls['type'].value == ReleaseCodeType.both || this.form.controls['type'].value == ReleaseCodeType.subscription)
      {
        this.isSubscription = true
        this.form.controls['subscriptionDuration'].setValidators([Validators.required])
      } else
      {
        this.isSubscription = false;
        this.form.controls['subscriptionDuration'].setValue(null)
        this.form.controls['subscriptionDuration'].clearValidators();
        this.form.controls['subscriptionDuration'].updateValueAndValidity();
      }

      if (this.form.controls['type'].value == ReleaseCodeType.prescription || this.form.controls['type'].value == ReleaseCodeType.both)
      {
        this.isPrescription = true;
      }
      else
      {
        this.isPrescription = false;
        this.form.controls['cbt'].setValue(false)
        this.form.controls['soundTherapy'].setValue(false)
      }


    })

    let l_sub1 = this.form.controls['subscriptionDuration'].valueChanges.subscribe(() =>
    {
      if (this.form.controls['subscriptionDuration'].value == SubscriptionDurationType.testing || this.form.controls['subscriptionDuration'].value == SubscriptionDurationType.freeTrial)
      {
        this.withDuration = true
        this.form.controls['trialDuration'].setValue(1)
        this.form.controls['trialDuration'].setValidators([Validators.required])
      } else
      {
        this.withDuration = false;
        this.form.controls['trialDuration'].setValue(null)
        this.form.controls['trialDuration'].clearValidators();
        this.form.controls['trialDuration'].updateValueAndValidity();
      }
    })

    this.subscription.add(l_sub)
    this.subscription.add(l_sub1)
  }

  ngOnDestroy(): void
  {
    this.subscription.unsubscribe()

  }

  onSubmit()
  {
    this.releaseCodeService.codeSettings = {
      count: this.form.controls['count'].value,
      type: this.form.controls['type'].value,
      prescription: { soundTherapy: this.form.controls['soundTherapy'].value, cbt: this.form.controls['cbt'].value },
withQRcodes:this.form.controls['withQRcodes'].value,
      regionId: environment.region,
      countryOfCreation: this.form.controls['countryOfCreation'].value,
      subscriptionDuration: this.form.controls['subscriptionDuration'].value,
    }
    this.loaded.next(false)
    this.releaseCodeService.generateReleaseCodes().pipe(first(l_resp => l_resp == true)).subscribe(l_resp =>
    {
      this.loaded.next(l_resp)
      this.dialogRef.close('Excelent')
    })
  }


  isDisabledButton(): boolean
  {
    let l_disabled = false
    if (!this.form.valid || this.form.controls['type'].value == ReleaseCodeType.none) l_disabled = true
    return l_disabled
  }

  getSubscriptionDurationText(type: SubscriptionDurationType)
  {
    return this.serverValueInterpreterService.getSubscriptionDurationText(type)
  }

  getFullCountryNameById(countryId: CountryId): CountriesEnum
  {
    return this.serverValueInterpreterService.getFullCountryNameById(countryId)
  }
}
